<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Recurring Maintenance'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true" [isPrimaryLayer]="true">


    <ng-container>

      <tidy-recurring-tasks-filter
        [addresses]="addressResponse"
        [loaded]="loaded"
        (filter)="onFilterChanges($event)"
        (searchChange)="onSearchChanges($event)"
        (onAddTask)="openMaintenanceModal()" />

      @if (loaded) {
        <tidy-card style="margin-top: 20px">
          <div style="overflow-x: auto">
            <table class="maintenance-list-table">
              <thead>
                <tr class="maintenance-list-header">
                  <th>
                    <tidy-text [header]="'Title'" />
                  </th>
                  <th>
                    <tidy-text [header]="'Property'" />
                  </th>
                  <th>
                    <tidy-text [header]="'Item'" />
                  </th>
                  <th>
                    <tidy-text [header]="'Next Date'" />
                  </th>
                  <th></th>
                </tr>
              </thead>
              @if (maintenancePlans?.length > 0) {
                <tbody>
                  @for (maintenance of filteredMaintenancePlans; track maintenance; let i = $index) {
                    <tr
                      (click)="openEditMaintenance(maintenance)"
                      class="maintenance-list-item">
                      <td>
                        <tidy-text
                          [body]="maintenance?.name" />
                      </td>
                      <td>
                        <tidy-text
                          [body]="maintenance?.address.address_name || maintenance?.address.address1"
                          [translate]="false" />
                      </td>
                      <td>
                        <tidy-text
                          [body]="maintenance?.room_object?.name || '-'" />
                      </td>
                      <td>
                        <tidy-text
                          [body]="maintenance?.next_do_date | parseDateTime: 'MMM d'" />
                      </td>
                      <td style="text-align: end;">
                        <ion-icon
                          name="chevron-forward-outline"
                          class="chevron-icon" />
                      </td>
                    </tr>
                  }
                </tbody>
              }
            </table>
          </div>
        </tidy-card>
      }

      @if (!loaded) {
        <ion-row>
          <ion-col>
            <ion-skeleton-text
              animated="true"
              style="
                width: 100%;
                height: 800px;
                border-radius: 6px;" />
          </ion-col>
        </ion-row>
      }

    </ng-container>

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" />